
export default function AboutPSU() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-purple-400 mb-8">
            About PSU
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-400 to-purple-400 mx-auto mb-8"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
              <span className="text-emerald-400 font-bold">PSU</span> is a streamer recruitment and ranking hub for the <span className="text-purple-400 font-bold">Pump.fun ecosystem</span>. We help creators grow, connect, and get rewarded for streaming Pump.fun content.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-emerald-500/10 to-purple-500/10 p-6 rounded-2xl border border-emerald-500/20">
                <div className="w-12 h-12 bg-emerald-500/20 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-community-fill text-emerald-400 text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Community First</h3>
                <p className="text-gray-300">Building the strongest streamer community in crypto</p>
              </div>
              
              <div className="bg-gradient-to-br from-purple-500/10 to-emerald-500/10 p-6 rounded-2xl border border-purple-500/20">
                <div className="w-12 h-12 bg-purple-500/20 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-trophy-fill text-purple-400 text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Reward Excellence</h3>
                <p className="text-gray-300">Top performers get exclusive rewards and recognition</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <div className="flex items-center bg-emerald-500/10 px-4 py-2 rounded-full border border-emerald-500/20">
                <i className="ri-check-line text-emerald-400 mr-2"></i>
                <span className="text-gray-200 font-medium">Verified Streamers</span>
              </div>
              <div className="flex items-center bg-purple-500/10 px-4 py-2 rounded-full border border-purple-500/20">
                <i className="ri-check-line text-purple-400 mr-2"></i>
                <span className="text-gray-200 font-medium">Weekly Rankings</span>
              </div>
              <div className="flex items-center bg-emerald-500/10 px-4 py-2 rounded-full border border-emerald-500/20">
                <i className="ri-check-line text-emerald-400 mr-2"></i>
                <span className="text-gray-200 font-medium">Exclusive Rewards</span>
              </div>
            </div>

          </div>

          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://public.readdy.ai/ai/img_res/451cfe8e96b49182ef728eff376c7ba6.jpg"
                alt="PSU Campus"
                className="w-full rounded-3xl shadow-2xl object-cover"
              />
            </div>
            <div className="absolute -top-4 -right-4 w-full h-full bg-gradient-to-br from-emerald-500/20 to-purple-500/20 rounded-3xl -z-10"></div>
            <div className="absolute -bottom-4 -left-4 w-full h-full bg-gradient-to-tr from-purple-500/20 to-emerald-500/20 rounded-3xl -z-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
